import type {
  PersonProfile,
  PersonProfileLite,
} from '@openeducation/oe-rn-shared-types';
import { atom } from 'jotai';

export const studentProfileAtom = atom<
  PersonProfile | PersonProfileLite | null
>(null);
